import { empApi } from "./client";

// =============================================================
// API Quản lý thu nhập (đối chiếu theo nhân viên / vùng / khối).
// Khớp IncomeManagementApiEndPoint của app.
// =============================================================

// Nhân viên
export const getIncomeCompareEmployeeStatisticApi = (params) =>
  empApi.get("/locking/app/manager/compare/employee/statistic", params);
export const getIncomeCompareEmployeeListApi = (params) =>
  empApi.get("/locking/app/manager/compare/employee/list", params);

// Khối
export const getIncomeCompareBlockStatisticApi = (params) =>
  empApi.get("/locking/app/manager/compare/block/statistic", params);
export const getIncomeCompareBlockListApi = (params) =>
  empApi.get("/locking/app/manager/compare/block/list", params);

// Vùng
export const getIncomeCompareAreaStatisticApi = (params) =>
  empApi.get("/locking/app/manager/compare/area/statistic", params);
export const getIncomeCompareAreaListApi = (params) =>
  empApi.get("/locking/app/manager/compare/area/list", params);

// Danh sách locking chi tiết theo từng nhóm
export const getIncomeSummaryEmployeeLockingsApi = (params) =>
  empApi.get("/incomeSummary/app/employee/lockings", params);
export const getIncomeSummaryBlockLockingsApi = (params) =>
  empApi.get("/incomeSummary/app/block/lockings", params);
export const getIncomeSummaryAreaLockingsApi = (params) =>
  empApi.get("/incomeSummary/app/area/lockings", params);

// Thu nhập chờ chi trả (đã tính PDV, chưa chi trả hết) - phía quản lý
export const getManagerUnpaidEmployeeListApi = (params) =>
  empApi.get("/commission/app/manager/unpaid/employees", params);
export const getManagerUnpaidLockingListApi = (params) =>
  empApi.get("/commission/app/manager/unpaid/lockings", params);

// Chi tiết 1 locking theo từng nhóm
export const getIncomeSummaryEmployeeLockingDetailApi = (params) =>
  empApi.get("/incomeSummary/app/employee/detail", params);
export const getIncomeSummaryBlockLockingDetailApi = (params) =>
  empApi.get("/incomeSummary/app/block/locking/detail", params);
export const getIncomeSummaryAreaLockingDetailApi = (params) =>
  empApi.get("/incomeSummary/app/area/locking/detail", params);
